import { Link, createFileRoute } from '@tanstack/react-router'
import { Pill, Skeleton, formatCount, fullTime, shortAddress, timeAgo } from '@algoboo/ui'
import { adminUsersQuery, useAdminUsers } from '../lib/admin'
import { useSession } from '../components/session'
import { AdminError, MoreButton, Table, Td } from '../components/admin/parts'
import { prefetchSignedIn } from '../lib/route-data'

export const Route = createFileRoute('/admin/users')({
  loader: ({ context: { queryClient: qc } }) => prefetchSignedIn(qc, (me) => [me.isAdmin !== false && qc.ensureInfiniteQueryData(adminUsersQuery())]),
  component: AdminUsersPage,
})

function AdminUsersPage() {
  const { me } = useSession()
  const q = useAdminUsers(!!me)
  const items = q.data?.pages.flatMap((p) => p.items) ?? []
  if (q.isLoading) return <Skeleton className="h-64 rounded-xl" />
  if (q.error) return <AdminError error={q.error} refetch={() => void q.refetch()} />
  return (
    <>
      <Table head={['User', 'Wallet', 'Plan', 'Agents', 'Wallets', 'Last seen', 'Joined']} testId="admin-users" caption="Users, newest first">
        {items.map((r) => (
          <tr key={r.user.id} data-testid="admin-user">
            <Td>
              <span className="font-medium text-ink">{r.user.displayName}</span>{' '}
              {r.user.handle && (
                <Link to="/u/$handle" params={{ handle: r.user.handle }} className="font-mono text-[12px] text-ink-3 hover:underline">
                  @{r.user.handle}
                </Link>
              )}
              {r.user.status === 'suspended' && (
                <Pill tone="bad" className="ml-2">
                  suspended
                </Pill>
              )}
            </Td>
            <Td mono className="text-ink-2" title={r.user.primaryAddress}>
              {shortAddress(r.user.primaryAddress)}
            </Td>
            <Td mono>{r.planId ?? <span className="text-ink-4">—</span>}</Td>
            <Td mono>{formatCount(r.agentsCount)}</Td>
            <Td mono>{formatCount(r.walletsCount)}</Td>
            <Td mono className="whitespace-nowrap text-ink-3">
              {r.lastSeenAt ? (
                <time dateTime={r.lastSeenAt} title={fullTime(r.lastSeenAt)}>
                  {timeAgo(r.lastSeenAt)}
                </time>
              ) : (
                '—'
              )}
            </Td>
            <Td mono className="whitespace-nowrap text-ink-3">
              <time dateTime={r.user.createdAt} title={fullTime(r.user.createdAt)}>
                {timeAgo(r.user.createdAt)}
              </time>
            </Td>
          </tr>
        ))}
      </Table>
      <MoreButton hasNext={q.hasNextPage} loading={q.isFetchingNextPage} onMore={() => void q.fetchNextPage()} />
    </>
  )
}
